'use strict';

import { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import GridPrint from './Header/GridPrint.react';
import FeedTools from './Header/FeedTools.react';
import Dropdown from '../../pro/components/Widgets/Dropdown.react';
import { getMealTypesForDate } from '../../utils/Meals';
import { useMealTypeValue, useMealTypeActions, useMealTypeNavigation } from '@components/MealType/MealTypeProvider.react';

import Analytics from '../../utils/Analytics';

import './Header.scss';

export default class Header extends Component {
    static propTypes = {
        onToggleView: PropTypes.func,
        currentView: PropTypes.string,
        onRefreshMealFeed: PropTypes.func,
    };

    static contextTypes = {
        router: PropTypes.object,
        plans: PropTypes.array,
        meals: PropTypes.array,

        user: PropTypes.object,
        preferences: PropTypes.object,
        family: PropTypes.array,
        startAddMeal: PropTypes.func,

        isMobile: PropTypes.bool,
        iPhone: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            printDate: moment(),
        };
    }

    openPrefsEditor = () => {
        const { router } = this.context;
        router.push('/preferences');
    }

    render = () => {
        const { onToggleView, currentView } = this.props;
        const { user, preferences, plans } = this.context;
        const now = moment();
        const mealTypes = getMealTypesForDate(now, plans, preferences?.meal_types || []);

        // MealTypeDropdown component using hooks inside render
        const MealTypeDropdown = () => {
            const { currentMealType: activeMealType } = useMealTypeValue();
            const { setMealType } = useMealTypeActions();
            const { syncNavigationToCurrent } = useMealTypeNavigation();

            const meals_icons = {
                'Breakfast': {
                    icon: <i className="icon-breakfast2" />,
                    selected: <i className="icon-breakfast-white" />,
                },
                'Snack': {
                    icon: <i className="icon-snacks3"><span className="path1" /><span className="path2" /><span className="path3" /><span className="path4" /><span className="path5" /><span className="path6" /></i>,
                    selected: <i className="icon-snack-white"><span className="path1" /><span className="path2" /><span className="path3" /><span className="path4" /><span className="path5" /><span className="path6" /><span className="path7" /><span className="path8" /><span className="path9" /><span className="path10" /></i>,
                },
                'Lunch': {
                    icon: <i className="icon-lunch3"><span className="path1" /><span className="path2" /><span className="path3" /><span className="path4" /><span className="path5" /></i>,
                    selected: <i className="icon-lunch-white"><span className="path1" /><span className="path2" /><span className="path3" /><span className="path4" /><span className="path5" /><span className="path6" /><span className="path7" /><span className="path8" /></i>,
                },
                'Dinner': {
                    icon: <i className="icon-salad" />,
                    selected: <i className="icon-dinner-white" />,
                },
            };

            const onClickMealTypeButton = (mealType) => {
                const { startAddMeal, meals } = this.context;
                const mealsThis = meals.filter(m => now.isSame(m.date, 'day') && m.meal == mealType);

                Analytics.changeCurrentMealType({'Meal Type': mealType});

                // Set meal type via MealType V2 system
                setMealType(mealType, true); // true = manual selection

                // Navigate to today's date with the selected meal type
                if (syncNavigationToCurrent) {
                    // This will set shouldNavigateToToday flag which Feed will handle
                    syncNavigationToCurrent();
                }

                // If there are no meals scheduled for today, then we add them.
                if (!mealsThis.length) {
                    startAddMeal(now, mealType);
                }
            };

            return (
                <Dropdown defaultClassName="select-meal-type-dropdown" className="el-toolbar-popup"
                    button={[<i key="icon" className="icon-clock3" />, <span key="text">Up Next: <em>{activeMealType?.toUpperCase()}</em></span>]}>
                    <div className="select-meal-type">
                        <div className="select-meal-scrollable">
                            <div className='next-meal-container'>
                                <p className="next-meal"><em>{activeMealType} is your next scheduled meal.</em></p>
                                <p>To change your current meal time, select below.</p>
                            </div>
                            <section className="select-meal-table">
                                {mealTypes.map(type => {
                                    return (
                                        <div key={type.name}>
                                            <button onClick={() => onClickMealTypeButton(type.name)}
                                                 data-selected={activeMealType == type.name}>
                                                {activeMealType == type.name ? meals_icons[type.main_dish]?.selected : meals_icons[type.main_dish]?.icon} {type.name}
                                            </button>
                                        </div>
                                    );
                                })}
                            </section>
                        </div>
                    </div>
                </Dropdown>
            );
        };

        let headerButtons = [
            <MealTypeDropdown key="meal-type" />,
            <Link to="/log" key="log">
                <button className={classNames("el-toolbar-btn")}>
                    <i className="icon-pencil-notebook" /><span>Daily Log</span>
                </button>
            </Link>,
            <button className="preferences-btn el-toolbar-btn" onClick={this.openPrefsEditor} key="prefs">
                <i className="icon-settings" />
                <span>Preferences</span>
            </button>,
            <GridPrint key="print" />,
            user?.capabilities?.publish ? <FeedTools key="tools" /> : null,
            <div key="grid-btn">
                <button onClick={onToggleView} className="grid-toggle-btn el-toolbar-btn">
                    <i className={currentView === 'feed' ? "icon-expand1" : "icon-collapse"} />
                    <span>{currentView === 'feed' ? 'Expand' : 'Single Meal View'}</span>
                </button>
            </div>
        ].filter(v => v);

        return (
            <div className="meal-feed-header sub-navigation" data-feed-mode={currentView}>
                <div className="dark-section" data-buttons={headerButtons.length}>
                    <div className="el-toolbar1">
                        {headerButtons && headerButtons.map((btn, i) => {
                            return (
                                <div className="el-toolbar-menu-item" key={i}>
                                    {btn}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}